import { FormControl, FormLabel, InputLabel, MenuItem, Select } from "@mui/material";
import { useGetQuotePayment } from "@store/QuoteData";
import { usePolicyStore } from "@store/policyStore";
import { useEffect } from "react";


export function PaymentSelectField(){
    const { policy, addPolicyInfo } = usePolicyStore();
    const { Packages, setPackage } = useGetQuotePayment();

    useEffect(() => {
      if(policy.package_new === 'AMPI') {
        policy.package_new = 'AMP'
        setPackage('Plan Amplio', 'AMP')
      }
    },[])
   
    const changePackage = (e: any) => {
        if(!policy.error){
          policy.package_anterior = Packages.value;
        }
        policy.package_new = e.target.value;
        addPolicyInfo({ ...policy });
        if (e.target.value === 'AMP') {
          setPackage('Plan Amplio', 'AMP');
          return;
        } else if (e.target.value === 'RC') {
          setPackage('Plan Basico', 'RC');
          return;
        } else if (e.target.value === 'LIMIT') {
          setPackage('Plan Limitado', 'LIMIT');
          return;
        }
      };
    return (
        <FormControl fullWidth>
            <FormLabel sx={{ fontSize: '14px', fontWeight: '400', marginBottom: '10px'}}>Plan</FormLabel>
            <Select
                value={policy.package_new}
                onChange={changePackage}
            >
                {[
                { label: 'Amplio', value: 'AMP' },
                { label: 'Limitado', value: 'LIMIT' },
                {
                    label: 'Básico',
                    value: 'RC',
                },
                ].map((value, i) => (
                <MenuItem key={i} value={value.value}>
                    {value.label}
                </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}